var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { selectAppContent } from "@adm-media/adam-store-plugin";
import { useSelector } from "react-redux";
import Typography from "../../components/ui/Typography/Typography";
import "./Maintenance.scss";
var Title = Typography.Title;
export var MaintenancePage = function () {
    var contents = useSelector(selectAppContent);
    return (_jsx("div", __assign({ "data-testid": "maintenance", className: "maintenance" }, { children: _jsx(Title, __assign({ level: 2, className: "maintenance__text" }, { children: contents.maintenance_message })) })));
};
